import {Check} from '@sparkware/app-utils';
import {decodeUriComponentRecursive} from '../../../../utils/url-utils';

interface ParameterDescriptor {
  originalName: string;
  value: string;
}

export class UriParams {

  private readonly _originalQueryParams: string;
  constructor(queryParamsString: string) {
    queryParamsString = (queryParamsString || '').trim();


    if(queryParamsString[0] === '?') {
      queryParamsString = queryParamsString.substring(1);
    }

    this._originalQueryParams = queryParamsString;

    if(this._originalQueryParams) {
        queryParamsString.split('&').forEach(paramString => {
            let keyValue = paramString.split('=');
            let key = keyValue[0];
            let value = keyValue[1];
            if(keyValue.length > 2) {
              value = keyValue.slice(1).join('=');
            }
            this._params[key.toLowerCase()] = {
                originalName: key,
                value: value
            };
        });
    }
  }

  private _params: {[key: string]: ParameterDescriptor} = {};

  getParamValue(paramName: string): string {
    let paramDescriptor = this._params[paramName.toLowerCase()];
    if(!paramDescriptor) {
      return undefined;
    }
    return decodeUriComponentRecursive(paramDescriptor.value);
  }

  toString() {
    if(!this._originalQueryParams) {
      return this._originalQueryParams;
    }
    if(this._originalQueryParams[0] === '?') {
      return this._originalQueryParams;
    } else {
      return '?' + this._originalQueryParams;
    }
  }

  removeParam(paramName: string): UriParams {
    let clonedParams = {...this._params};
    delete clonedParams[paramName?.toLowerCase()];
    const newQueryParams = Object.keys(clonedParams).map(paramName => {
        const paramDescriptor = clonedParams[paramName];
        return `${paramDescriptor.originalName}=${paramDescriptor.value}`;
    });
    return new UriParams(newQueryParams.join('&'));
  }

  equals(theOther: UriParams): boolean {
    let keys1 = Object.keys(this._params);
    let keys2 = Object.keys(theOther._params);

    if(keys1.length !== keys2.length) {
      return false;
    }

    for(let i = 0; i < keys1.length; i++) {
      let paramName = keys1[i];
      let val1 = this._params[paramName].value;
      let val2 = theOther._params[paramName] && theOther._params[paramName].value;
      if (val1 !== val2) {
        return false;
      }
    }

    return true;
  }

  get isEmpty(): boolean {
    return Check.isEmpty(this._originalQueryParams);
  }
}
